/* tslint:disable */
import { Injectable } from '@angular/core';
import { VARS } from '../constants/constants.service';

/**
 * Global configuration for Api services
 */
@Injectable({
  providedIn: 'root',
})
export class ApiConfiguration {
    //DEV
    // baseUrlNew ='https://api.centuryply.bigcityvoucher.co.in/v1/';
    //UAT
  //  baseUrlNew = 'https://api.centuryplyuat.bigcityvoucher.co.in/v1/'; 
    
    // Prod
    baseUrlNew = 'https://appapi.centuryply.bigcitydays.in/v1/'; 
    // VB
    // baseUrlNew = "http://192.168.1.146/zcentuaryply/centuryply_app_api/api/web/v1/"
    // 
    loginUrl ='user/login';
    verifyotp = 'user/verifyotp'; 
    resendOTP = this.baseUrlNew+'user/resendotp'; 
    getAppInfo =  this.baseUrlNew + 'user/get-app-info';
    tearmsUpdate = this.baseUrlNew + 'user/termsupdate';
    updateProfile = this.baseUrlNew + "user/update-profile";
    pointLedger = this.baseUrlNew+'user/user-points-summary?program_id=1'

    invoiceList = this.baseUrlNew+'invoice/list-invoice?program_id='+VARS.PROGRAM_ID;
    createInvoice=this.baseUrlNew+'invoice/create-invoice'
    categoryList = this.baseUrlNew+'invoice/category-list?program_id='+VARS.PROGRAM_ID;
    projectCategory=this.baseUrlNew+'invoice/project-category-list?program_id='+VARS.PROGRAM_ID;
    getDeco = this.baseUrlNew+'queries/getdecodhamaka?program_id='+VARS.PROGRAM_ID;
    decoPointSummary = this.baseUrlNew+'user/get-user-point-summary-details?program_id='+VARS.PROGRAM_ID;
    bounsSummary = this.baseUrlNew+'user/user-bonus-points?program_id='+VARS.PROGRAM_ID;

    getEditProfileInfo = this.baseUrlNew + "user/edit-profile?program_id="+VARS.PROGRAM_ID;
    getUserModules = this.baseUrlNew + "user/list-user-modules?program_id="+VARS.PROGRAM_ID;
    getPrivileges = this.baseUrlNew + "reward/getprivileges?program_id="+VARS.PROGRAM_ID;
    getPrivilegesDetail = this.baseUrlNew + "reward/getprivilegebyid?program_id="+VARS.PROGRAM_ID+"&privilege_id=";
    getOffers = this.baseUrlNew + "reward/getoffers?program_id="+VARS.PROGRAM_ID;
    privilegeBooking = this.baseUrlNew + "reward/privilegebooking";
    getCity = this.baseUrlNew + "reward/getcity?program_id="+VARS.PROGRAM_ID;
    getVenue = this.baseUrlNew + "reward/getvenue?program_id="+VARS.PROGRAM_ID+"&privilege_id=";
    claimOffer = this.baseUrlNew + "reward/claimoffer";
    getActivityRecord = this.baseUrlNew + "reward/getbookings?program_id="+VARS.PROGRAM_ID;
    getQuery = this.baseUrlNew + 'queries/get-query-types?program_id='+VARS.PROGRAM_ID
    getSubQuery = this.baseUrlNew + 'queries/get-query-sub-types?program_id='+VARS.PROGRAM_ID
    submitQuery = this.baseUrlNew + 'queries/send-enquiry'
    getProgramDetails = this.baseUrlNew + 'user/program-details?program_id=' + VARS.PROGRAM_ID
    getFaq = this.baseUrlNew + 'faqs/get-faqs?program_id=' + VARS.PROGRAM_ID
    getClaimedData = this.baseUrlNew + 'reward/rewarddetails?program_id=' + VARS.PROGRAM_ID
    getEngagement = this.baseUrlNew + 'engagement/get-engagement?program_id=' + VARS.PROGRAM_ID;
    bookEngagement = this.baseUrlNew + 'engagement/book-engagement';
    getCenturyHub = this.baseUrlNew + 'brand-hub/get-brand-hub?program_id=' + VARS.PROGRAM_ID + '&brand_hub_type=';
    getTerritory = this.baseUrlNew + 'user/get-regions?program_id='+ VARS.PROGRAM_ID;
    getState = this.baseUrlNew + 'user/get-state-byregion?program_id='+ VARS.PROGRAM_ID+'&region_id=';
    getCityList = this.baseUrlNew + 'user/get-city-bystate?program_id='+ VARS.PROGRAM_ID+'&state_id=0&branch_id=';
    getBranch = this.baseUrlNew + 'user/get-branch-bycity?program_id='+ VARS.PROGRAM_ID+'&state_id=';
    submitEnrollmentStep1 = this.baseUrlNew + 'user/enrollment-otp';
    submitEnrollmentOTPVerify = this.baseUrlNew + 'user/enrollment-otp-verification';
    getEnrollmentDetails = this.baseUrlNew + 'user/getaid-byid?program_id='+ VARS.PROGRAM_ID+'&user_id=';
    userEnroll = this.baseUrlNew + 'user/enroll-user';
    enrollStatus = this.baseUrlNew + 'user/enrollment-status?program_id='+ VARS.PROGRAM_ID;
    getNotification = this.baseUrlNew + 'notification/getnotification?program_id='+ VARS.PROGRAM_ID;
    readNotification = this.baseUrlNew + 'notification/notificationread';
    getTestimonials = this.baseUrlNew + 'testimonials/get-testimonials?program_id='+ VARS.PROGRAM_ID;
    enrollJuniorUser = this.baseUrlNew + 'user/enroll-junior-architect';
    getAID = this.baseUrlNew + 'user/get-aid?program_id='+ VARS.PROGRAM_ID;
    getJAID = this.baseUrlNew + 'user/get-junior-aid?program_id='+ VARS.PROGRAM_ID+'&id=';
    deleteJAID = this.baseUrlNew + 'user/delete-aid?program_id='+ VARS.PROGRAM_ID;
    getCourses = this.baseUrlNew + 'course/getcourses?program_id='+ VARS.PROGRAM_ID;
    getCourseDetail = this.baseUrlNew + 'course/getcoursebyid?program_id='+ VARS.PROGRAM_ID+"&course_id=";
    claimCourse = this.baseUrlNew + 'course/claimcourse';
    getCourseForList = this.baseUrlNew + 'course/coursefor?program_id='+ VARS.PROGRAM_ID;
    getCourseCityList = this.baseUrlNew + 'course/getcity?program_id='+ VARS.PROGRAM_ID;
    UploadCertificate = this.baseUrlNew + 'course/upload_course_certificate';



    //new version API's

    lead_projectsList = this.baseUrlNew+'leads/get-leads?program_id='+VARS.PROGRAM_ID
    project_list_byID = this.baseUrlNew +'leads/get-lead-details?program_id='+VARS.PROGRAM_ID
    createSchedule = this.baseUrlNew+'visits/create-visit?program_id='+VARS.PROGRAM_ID
    getVisits = this.baseUrlNew+'visits/get-visits-by-role?program_id='+VARS.PROGRAM_ID
    getSlots = this.baseUrlNew+'visits/get-timeslots?program_id=1'
    monthly_statcs = this.baseUrlNew+'leads/get-leads-by-year?program_id='+VARS.PROGRAM_ID
    monthly_details =  this.baseUrlNew+'leads/get-leads-by-month?program_id='+VARS.PROGRAM_ID
    lead_monthly_details = this.baseUrlNew+'leads/get-lead-details-by-month-and-year?program_id='+VARS.PROGRAM_ID
    product_points = this.baseUrlNew+ 'user/get-product-points?program_id='+VARS.PROGRAM_ID
    getAsmNumber = this.baseUrlNew+'user/get-supervisor-number?program_id='+VARS.PROGRAM_ID
    getAIDList = this.baseUrlNew +'leads/aid-mapped-details-by-asm-bdm-id?program_id='+VARS.PROGRAM_ID
    infulencerSummary = this.baseUrlNew+'leads/influencer-summary?program_id='+VARS.PROGRAM_ID
    leaderBoard = this.baseUrlNew + 'leads/leader-board?program_id='+VARS.PROGRAM_ID
    updateEmail = this.baseUrlNew+'leads/update-email?program_id='+VARS.PROGRAM_ID
    requestReport = this.baseUrlNew+'leads/request-report?program_id='+VARS.PROGRAM_ID
    //points_summary = this.baseUrlNew+ 'user/get-user-point-summary-details?program_id='+VARS.PROGRAM_ID

    //new rewards
rewardsCategoryList = this.baseUrlNew + 'product/list-product-categories?program_id=1';
rewardsCategory = this.baseUrlNew + 'reward/categories?rewardtype=';
rewardsSubCategory = this.baseUrlNew + 'reward/sub-categories?category_id=';
productlistbycategory =this.baseUrlNew+ 'reward/productlistbycategory?program_id=' + VARS.PROGRAM_ID;
getCartDetails = this.baseUrlNew + 'rewards/list-cart';
getAddress = this.baseUrlNew + 'rewards/getuseraddress';
checkout = this.baseUrlNew + 'rewards/orders';
rewardOtp = this.baseUrlNew +'rewards/sendotpcustomer'
deletecartbyproduct = 'reward/deletecartbyprod';
offerDetails = this.baseUrlNew + 'rewards/orderoffercode?program_id=1';
deleteProductInCart = this.baseUrlNew + 'rewards/deletecartbyprod';
getProductsOnFilter = this.baseUrlNew + 'product/list-products'
savecart_rewards = this.baseUrlNew +'rewards/save-cart';
placeToOrder = this.baseUrlNew +'rewards/orders'
rewardHistory = this.baseUrlNew +'rewards/orderhistory'
rewards_historys = this.baseUrlNew + "rewards/redemption-summary";
get_reward_denaminations = 'reward/productdetails?program_id=';
verifyRewardOtp = this.baseUrlNew + 'reward/verify-otp'
rewards_history = this.baseUrlNew+"reward/orderhistory";
productDetails = this.baseUrlNew+'rewards/productdetails'
saveReward = this.baseUrlNew+'rewards/save-cart'
trackCashtranscation = this.baseUrlNew+'reward/cashorderdetail'
ordertrack = this.baseUrlNew+'rewards/get-cartonorders'

cash_order_summary = this.baseUrlNew+'loyalty/cash-order-summary?program_id=1'
cash_order_confirm = this.baseUrlNew+'loyalty/cash-order-conversion?program_id=1'
cashledger =  this.baseUrlNew+'loyalty/user-cash-summary?program_id=1'
confirmCash_order = this.baseUrlNew+'loyalty/cash-order-confirm?program_id=1'

reward_order_voucher_details = this.baseUrlNew + 'reward/getorderoffercode?program_id=' + '&order_access_token=';

getStateList = this.baseUrlNew + 'user/getstatelist';
  cities = this.baseUrlNew + 'user/getcitylistbystate?program_id=1'

  getCityLists = this.baseUrlNew + 'user/getcitylist';
  shipping_cart = this.baseUrlNew + 'reward/addshippingaddress?program_id=' + VARS.PROGRAM_ID;
  cashbackcheckOut = this.baseUrlNew+'cashback/cashback-checkout'
  getAddressList = this.baseUrlNew + "reward/get-shipping-address-by-user?program_id="+ VARS.PROGRAM_ID;
  updateShippingAddress = this.baseUrlNew + "reward/update-shipping-address";

}
export interface ApiConfigurationInterface {
    baseUrl?: string,
    baseUrlNew?:string,
    logInUrl?:string
}


